"use client";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export function useScheduleById(scheduleId: string | null) {
  return useQuery({
    queryKey: ["schedule", scheduleId],
    queryFn: async () => {
      if (!scheduleId) return null;
      const result = await api.client.schedules.scheduleById(scheduleId);
      return result.result;
    },
    enabled: !!scheduleId
  });
}
